import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const Headline = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box marginBottom={2}>
        <Typography
          variant="h2"
          align={'center'}
          sx={{
            fontWeight: 700,
          }}
        >
          {t('contact.contactUs')}
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" align={'center'} color={'textSecondary'}>
          {t('contact.requestInfo')}
        </Typography>
      </Box>
    </Box>
  );
};

export default Headline;
